import styles from "./placeholder-search-form-filter.less";

export const PlaceholderSearchFormFilter = () => {
    return <div className={styles.placeholderSearchFormFilter}></div>
};